/**
 * Created by Administrator on 2017/10/30.
 */
import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { HttpService } from "../service/http-service";
import { FileUpload } from "../service/file-upload";
import { API } from "../config/api-config";
declare var alertify: any;
@Component({
  templateUrl: './messageEdit.html'
})

export class MessageEdit implements OnInit {


  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpService,
    private fileupload: FileUpload,
    private location: Location
  ) { }

  private data: any = {
    'id': '',
    "imageEn": "",
    "imageTc": "",
    "messageEn": "",
    "messageTc": "",
    "titleEn": "",
    "titleTc": "",
    "urlEn": "",
    "urlTc": ""
  }

  private id: number = 0;
  private imagePath: string = '';
  private isCreate: boolean = false;
  private language = 'tc';
  private getData(): void {
    this.http.getData(API.messageDetail + '/' + this.id).then(res => {
      this.data = res.data;
    })
  }

  private showByLanguage(type: string) {
    this.language = type;
  }
  private getPath(): void {
    this.http.getData(API.resourcePath)
      .then(res => {
        this.imagePath = res.data;
        this.getData();
      })
  }


  private submit(): void {
    this.http.postData(API.messageCreateOrUpdate, {
      'id': this.id,
      "imageEn": this.data.imageEn,
      "imageTc": this.data.imageTc,
      "messageEn": this.data.messageEn,
      "messageTc": this.data.messageTc,
      "titleEn": this.data.titleEn,
      "titleTc": this.data.titleTc,
      "urlEn": this.data.urlEn,
      "urlTc": this.data.urlTc
    }).then(res => {
      let data = res;
      if (data.status.code == 0 || data.status.code == '0') {
        this.location.back();
        alertify.success(data.status.message);
      } else {
        alertify.error(data.status.message);
      }
    });
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.id = params['id'];
    });
    if (this.id != 0) {
      this.getPath();

    } else {
      this.isCreate = true;
    }
  }

  private showImageEn: boolean = false;
  private showImageTc: boolean = false;
  private tempPath: string = API.getTemp;
  private upload(name: string) {
    let self = this;
    this.fileupload.upload(function (res) {
      let temRes = JSON.parse(res);
      if (temRes.status.code == 0) {
        switch (name) {
          case 'imageEn': self.showImageEn = true; break;
          case 'imageTc': self.showImageTc = true; break;
        }
        self.data[name] = temRes.data.fileName;
      } else {
        alertify.error(temRes.status.message);
      }
    });
  }

}



// WEBPACK FOOTER //
// /Users/ken/Dev/workspace/snowmantech/naturallyplus/web-cms/src/app/message/messageEdit.component.ts